import { ModelFieldType, http } from '@kunlun/dependencies';

/**
 * 小导入接口
 *
 * @export
 * @param {*} model
 * @param {*} validateFunctionName
 * @param {*} data
 * @param {string} [formDataJson]
 * @return {*}
 */
export async function validateData(model, validateFunctionName, data, formDataJson?: string) {
  let modelName = model.model.split('.')[model.model.split('.').length - 1];
  modelName = modelName.charAt(0).toLowerCase() + modelName.slice(1);
  const query = `{
    ${modelName}Query{
      ${validateFunctionName}(
        data: [${data}]
        ${formDataJson ? `formDataJson: ${formDataJson}` : ''}
      ) {
        id
        ${model.modelFields
          .map((i) => {
            if (i.returnType === ModelFieldType.Enum) {
              return i.name.split('Str')[0];
            }

            if (i.referencesModel) {
              // FIXME: 这里没有考虑关联模型的枚举字段
              return `${i.name} { 
                ${i.referencesModel.modelFields.map((j) => j.name).join(' ')} 
              }`;
            }
            return i.name;
          })
          .join(' ')}
      }
    }
  }`;
  const result = await http.query<any[]>(model.moduleName, query);
  return result.data[modelName + 'Query'][validateFunctionName];
}
